export enum AdStatus {
  Pending = 'PENDING',
  Published = 'APPROVED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Archived = 'ARCHIVED',
}

export interface SelectOption {
  label: string;
  value: string;
  dataStat?: string;
}

export interface UploadImageResponse {
  photos: { id: string; thumbnail_url: string }[];
}
